import React from "react";
import "./TopNavbar.css";
import MailIcon from "@mui/icons-material/Mail";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link } from "react-router-dom";
import WifiCalling3Icon from "@mui/icons-material/WifiCalling3";
import {
  EMAIL_ADDRESS,
  FACEBOOK_URL,
  INSTGRAM_URL,
  LINKEDIN_URL,
  MOBILE_NUMBER,
  YOU_TUBE_URL,
} from "../../Constant/Global";
const TopNavbar = () => {
  return (
    <div class="top_nav">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-md-12 main_social">
            <div className="top_mail ">
              <MailIcon className="text-black fs-6" />
              <Link
                to={`mailto:${EMAIL_ADDRESS}`}
                className="mail_top_nav mx-2"
              >
                {EMAIL_ADDRESS}
              </Link>
              <WifiCalling3Icon className="text-black fs-6" />{" "}
              <Link to={`tel:${MOBILE_NUMBER}`} className="mail_top_nav">
                {MOBILE_NUMBER}
              </Link>
            </div>
            <div className="social_media ">
              <p class="social_media_name mb-0 mt-1">Follow Us On</p>
              <div className="social_icons">
                <Link to={INSTGRAM_URL} target="_blank">
                  <InstagramIcon className="text-white" fontSize="small" />
                </Link>
                <Link to={FACEBOOK_URL} target="_blank">
                  <FacebookIcon className="text-white" fontSize="small" />
                </Link>
                <Link to={YOU_TUBE_URL} target="_blank">
                  <YouTubeIcon className="text-white" fontSize="small" />
                </Link>
                <Link to={LINKEDIN_URL} target="_blank">
                  <LinkedInIcon className="text-white" fontSize="small" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopNavbar;
